import React, { useEffect, useState } from 'react';

import styles from './companyProfile.module.scss';
import UserLayout from '../../../components/user-layout/UserLayout';
import { Link } from 'react-router-dom';
import authService, { user$ } from '../../../utils/services/authService';
const CompanyProfile = () => {
  const [company, setCompany] = useState();
  const userData = authService.getUserData();

  useEffect(() => {
    const loggedIn = authService.checkLoggedIn();

    if (loggedIn) {
      if (userData.token !== undefined) {
        authService.getUserById(userData);

        user$.subscribe((data) => {
          if (company !== data) {
            setCompany(data.data.data[0]);
          }
        });
      }
    }
  }, []);
  return (
    <UserLayout>
      <header className={styles.header}>
        <h2 className={styles.companyName}>{company?.companyName}</h2>
      </header>
      <section className={styles.compProfileWrapper}>
        <section className={styles.shortInfo}>
          <div className={styles.compSize}>
            <p className={styles.companySize_heading}>Company Size</p>
            <p className={styles.companySize_value}>{company?.companySize}</p>
          </div>

          <div className={styles.compType}>
            <p className={styles.compType_heading}>Company Type</p>
            <p className={styles.compType_value}>{company?.companyType}</p>
          </div>
        </section>

        <section className={styles.bio}>
          <h2 className={styles.bio_title}>{company?.companyName}</h2>
          <p className={styles.bio_description}>{company?.description}</p>
        </section>

        <section className={styles.tech}>
          <h3>Tech we work with</h3>

          <div className={styles.techWrapper}>
            {company?.tech.map((item, index) => (
              <span key={index} className={styles.techWrapper_item}>
                {item}
              </span>
            ))}
          </div>
        </section>

        <section className={styles.jobs}>
          <h2>Avaliable positions</h2>
          {company?.jobPosts.map((job, index) => (
            <div key={index} className={styles.jobCard}>
              <h4 className={styles.jobCard_title}>{job.title}</h4>
              <p className={styles.jobCard_description}>{job.description}</p>
              <Link to={`/job/${job._id}`} className={styles.jobCard_btn}>
                View job post
              </Link>
            </div>
          ))}
        </section>

        <section className={styles.contact}>
          <h3 className={styles.contact_contactTitle}>Get in touch!</h3>
          <p className={styles.contact_title}>Address</p>
          <p className={styles.contact_value}>
            {company?.contact.address}, {company?.contact.zipCode},{' '}
            {company?.contact.city}, {company?.contact.country}
          </p>
          <p className={styles.contact_title}>Website</p>
          <a
            className={styles.contact_website}
            href={`${company?.contact_website}`}
            target="_blank"
            rel="noreferrer"
          >
            {company?.companyName}'s website
          </a>
        </section>
      </section>
    </UserLayout>
  );
};

export default CompanyProfile;
